import { makeStyles } from "@material-ui/core";

export const useTraceTooltipStyle = makeStyles((theme) => ({
    tooltipPopover: {
        borderRadius: 14,
        boxShadow: "22px 19px 34px rgba(0, 0, 0, 0.1)",
    },
}));
